import { find } from 'lodash-es'

import { WORLD_LEVELS, type WorldLevel } from '@/queries/constants'

import getWorldConfig from '../getWorldConfig'

export default function getNextLevel({
  currentLevel,
  worldSlug,
}: {
  currentLevel: WorldLevel
  worldSlug: string
}): WorldLevel | null {
  const worldConfig = getWorldConfig(worldSlug)
  const currentLevelIndex = WORLD_LEVELS.indexOf(currentLevel)

  if (currentLevelIndex === WORLD_LEVELS.length - 1) {
    return null
  }

  const nextLevel = find(
    WORLD_LEVELS,
    level => !worldConfig.levelsToSkip.includes(level),
    currentLevelIndex + 1 // fromIndex
  )

  return nextLevel ?? null
}
